ScreenDetectionService.SERVICE_NAME = 'screenDetectionService';
export default function ScreenDetectionService() {
    let _isMobile;

    Object.assign(this, {
        isMobile,
        setIsMobile,
    });

    function isMobile() {
        return _isMobile;
    }

    function setIsMobile(value) {
        _isMobile = value;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/common/screen-detection/screen-detection-service.js